import {
  API_STATUS,
  API_STATUS_MASTER,
  API_STATUS_MASTER_DATA,
  CLEAR_API_STATUS,
  GET_BATCH_DATA,
  GET_VALI_DATA,
  IS_SIGNATURE_UPLOADED_STATUS,
  PDF_AND_PAGE_DETAILS,
  UPDATE_FILTER,
  VALIDATE_USER_STATUS,
} from "./types";
import ValidationService from "../../services/validationService";
import { initialState } from "./initialState";
import { errorMessage } from "../../constants/responseMessages";

const service = new ValidationService();

export const clearApiStatus = () => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus },
    });
  };
};

export const updateType = (type) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_FILTER,
      payload: type,
    });
  };
};

export const getBatchDetailsList = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState.apiStatus, loader: true },
    });

    // dispatch({
    //   type: GET_BATCH_DATA,
    //   payload: {
    //     batches_for_review: [],
    //     total_count: 0,
    //   },
    // });

    dispatch({
      type: API_STATUS_MASTER_DATA,
      payload: { loader: true },
    });

    service
      .getBatchDetailsList(data)
      .then((res) => {
        const { results = [], pagination = {} } =
          res?.data?.data?.batches_for_review;

        dispatch({
          type: GET_BATCH_DATA,
          payload: {
            batches_for_review: results,
            total_count: pagination.total_count || 0,
            page: pagination.page,
            page_size: pagination.page_size,
            total_pages: pagination.total_pages,
          },
        });

        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            loader: false,
            apiSuccess: true,
          },
        });

        dispatch({
          type: API_STATUS_MASTER_DATA,
          payload: { loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_BATCH_DATA,
          payload: { batches_for_review: [], total_count: 0 },
        });

        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            apiError: true,
          },
        });

        dispatch({
          type: API_STATUS_MASTER_DATA,
          payload: { loader: false },
        });
      });
  };
};

export const getValiData = (projectId, batchId, forValue) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    dispatch({
      type: PDF_AND_PAGE_DETAILS,
      payload: {},
    });
    dispatch({
      type: GET_VALI_DATA,
      payload: [],
    });
    service
      .getValiData(projectId, batchId, forValue)
      .then((res) => {
        dispatch({
          type: API_STATUS,
          payload: { ...initialState?.apiStatus, loader: false },
        });

        dispatch({
          type: GET_VALI_DATA,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            message: errorMessage(error),
          },
        });
      });
  };
};

export const isSignatureUploaded = () => {
  return (dispatch) => {
    dispatch({
      type: IS_SIGNATURE_UPLOADED_STATUS,
    });
    service
      .isSignatureUploaded()
      .then((json) => {
        dispatch({
          type: IS_SIGNATURE_UPLOADED_STATUS,
          payload: {
            isSignatureUploaded: json?.data?.is_signature_uploaded,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: IS_SIGNATURE_UPLOADED_STATUS,
          payload: { message: errorMessage(error) },
        });
      });
  };
};

export const validateUserClear = () => {
  return (dispatch) => {
    dispatch({
      type: VALIDATE_USER_STATUS,
      payload: {},
    });
  };
};

export const validateData = (data) => {
  // columnsCount used in free-form only
  return (dispatch) => {
    !data.autosave === true &&
      dispatch({
        type: API_STATUS,
        payload: { ...initialState?.apiStatus, loader: true },
      });
    service
      .validateData(data)
      .then((res) => {
        !data.autosave === true &&
          dispatch({
            type: API_STATUS,
            payload: {
              ...initialState?.apiStatus,
              loader: false,
              next: data?.next,
              nextStep: true,
              message: res?.data?.message,
              isError: false,
            },
          });
        if (data.onSaveSuccess) {
          data.onSaveSuccess();
        }
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            message: errorMessage(error),
            isError: true,
          },
        });
      });
  };
};

export const rejectValidatorData = (data) => {
  // columnsCount used in free-form only
  return (dispatch) => {
    !data.autosave === true &&
      dispatch({
        type: API_STATUS,
        payload: { ...initialState?.apiStatus, loader: true },
      });
    service
      .rejectValidatorData(data)
      .then((res) => {
        !data.autosave === true &&
          dispatch({
            type: API_STATUS,
            payload: {
              ...initialState?.apiStatus,
              loader: false,
              next: data?.next,
              isRejected: true,
            },
          });
        if (data.onSaveSuccess) {
          data.onSaveSuccess();
        }
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            message: errorMessage(error),
          },
        });
      });
  };
};

export const pageRedirection = (data) => {
  return (dispatch) => {
    dispatch({
      type: PDF_AND_PAGE_DETAILS,
      payload: {
        data,
      },
    });
  };
};

export const submitEsignBatch = (userName, userId, userRole, userPassword) => {
  return (dispatch) => {
    dispatch({
      type: VALIDATE_USER_STATUS,
      payload: { message: "", loader: true },
    });
    service
      .esignHandle(userName, userId, userRole, userPassword)
      .then((json) => {
        dispatch({
          type: VALIDATE_USER_STATUS,
          payload: { message: "", loader: false, next: true, setSuccess: true },
        });
      })
      .catch((error) => {
        dispatch({
          type: VALIDATE_USER_STATUS,
          payload: {
            message: errorMessage(error),
            loader: false,
            setError: true,
          },
        });
      });
  };
};
